import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './s3handler.css';
import { LIST_IMAGES, DELETE_IMAGE } from '../../api/image.js';

const S3FileManager = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  // NEW: State for the confirmation modal
  const [showConfirm, setShowConfirm] = useState(false);
  const [imageToDelete, setImageToDelete] = useState(null);

  const fetchImages = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(LIST_IMAGES);
      setImages(data);
    } catch (err) {
      console.error("Error fetching images:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchImages(); }, []);

  // Open modal instead of window.confirm
  const openDeleteModal = (img) => {
    setImageToDelete(img);
    setShowConfirm(true);
  };

  // Close modal
  const closeDeleteModal = () => {
    setShowConfirm(false);
    setImageToDelete(null);
  };

  const confirmDelete = async () => {
    if (!imageToDelete) return;
    try {
      await axios.post(DELETE_IMAGE, {
        imageUrl: imageToDelete.url,
        imageId: imageToDelete.id
      });

      setImages(images.filter(img => img.url !== imageToDelete.url));
      closeDeleteModal();
    } catch (err) {
      alert("Delete failed: " + (err.response?.data?.error || "Unknown error"));
    }
  };
  if (loading) return <div className="portal-loader">Syncing with S3 Bucket...</div>;

  return (
    <div className="s3-manager-wrapper">
      {/* --- CUSTOM CONFIRMATION MODAL --- */}
      {showConfirm && (
        <div className="confirm-overlay">
          <div className="confirm-modal">
            <div className="confirm-icon">🗑️</div>
            <h4>Confirm Deletion</h4>
            <p>Are you sure you want to delete <strong>{imageToDelete?.key.split('/').pop()}</strong>?</p>
            <p className="confirm-warning">This action cannot be undone from S3 or the Database.</p>
            <div className="confirm-actions">
              <button className="btn-cancel" onClick={closeDeleteModal}>Keep it</button>
              <button className="btn-confirm-delete" onClick={confirmDelete}>Yes, Delete</button>
            </div>
          </div>
        </div>
      )}

      <div className="manager-header">
        <h3>Cloud Asset Library</h3>
        <button className="btn-refresh" onClick={fetchImages}>🔄 Refresh</button>
      </div>

      <div className="image-grid">
        {images.length === 0 ? (
          <p className="empty-msg">No images found in storage.</p>
        ) : (
          images.map((img, index) => (
            <div key={index} className="image-item-card">
              <div className="img-thumbnail-wrapper">
                <img src={img.url} alt="S3 Asset" />
              </div>
              <div className="img-details">
                <p className="img-key">{img.key.split('/').pop()}</p>
                <p className="img-size">{img.size}</p>
                <div className="item-actions">
                  <a href={img.url} target="_blank" rel="noreferrer" className="btn-view">View</a>
                  {/* Trigger Modal instead of handleDelete */}
                  <button className="btn-delete-icon" onClick={() => openDeleteModal(img)}>🗑️</button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default S3FileManager;